'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({

  constructor: function(options) {
    if (options && options.appointment) {
      this.appointment = options.appointment;
    }
    Marionette.View.apply(this, arguments);

    this.listenTo(Radio.channel('steps'), 'click:back', this.onBack);
    this.listenTo(Radio.channel('steps'), 'click:next', this.onNext);
  },

  isValid: function() {
    return this.appointment.isValid({step: Radio.channel('steps').request('current').get('slug')});
  },

  onBack: function() {
    Radio.channel('steps').trigger('back');
  },

  onNext: function() {
    Radio.channel('buttons').request('next:disable');
    if (this.isValid()) {
      if (!Radio.channel('details').request('duplicate')) {
        Radio.channel('steps').trigger('next');
      }
    } else if (this.appointment.validationError.toast) {
      Radio.channel('toast').trigger('show', {
        message: this.appointment.validationError.toast,
        icon: 'times-circle',
        iconColor: 'error',
      });
    }

    Radio.channel('buttons').request('next:enable');
  },

  showCookieMessage: function() {
    if (!$.cookie('cookiesAccepted')) {
      Radio.channel('long-toast').trigger('show', {
        message: polyglot.t('messages.cookies'),
        modalSize: 'large',
        buttonMessage: polyglot.t('messages.cookies_confirm'),
        buttonClass: 'cookie',
        showIcon: false,
      });
    }
  },
});
